<script setup lang="ts">
import { NButton } from 'naive-ui'

const reload = () => {
  window.location.reload()
}
</script>

<template>
  <div class="error-layout">
    <div class="error-content">
      <h1 class="error-title">エラーが発生しました</h1>
      <p class="error-message">
        時間をおいて再度お試しください。<br />
        問題が続く場合はスタッフにお声がけください。
      </p>
      <n-button type="primary" size="large" @click="reload">再読み込み</n-button>
    </div>
  </div>
</template>

<style scoped>
.error-layout {
  min-height: 100vh;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.error-content {
  max-width: 400px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.error-title {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
}

.error-message {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}
</style>
